module.exports = __webpack_public_path__ + "static/media/me3_ECAP_Statistics_Icon.06e10cfb.svg";